module.exports = __webpack_public_path__ + "img/a3.7b6ddee0.png";